import OrderStateCrud from './OrderStateCrud'
export {OrderStateCrud}
export default OrderStateCrud
